// const baseUrl="http://127.0.0.1:8000/api";
// const baseUrl="https://microfinance.amyfintech.com/backend/public/api";
// const baseUrl="https://drnwealthgroup.amyfintech.com/backend/public/api";
const baseUrl="https://microfinance.msrcrestcapital.com/backend/public/api";
// const baseUrl="https://nalanfs.com/finance/backend/public/api";

export default baseUrl;


